(() => {
  if (document.documentElement.hasAttribute('data-bronkey-variant-technical-ready')) return;
  document.documentElement.setAttribute('data-bronkey-variant-technical-ready', '');
  document.addEventListener('variant-change', (event) => {
    const root = event.target.closest && event.target.closest('.product_section');
    if (!root) return;
    const variant = event.detail && event.detail.variant;
    const sku = variant && variant.sku ? String(variant.sku).replace(/^SKU:\s*/i, '').trim() : '';
    const barcode = variant && variant.barcode ? String(variant.barcode).trim() : '';
    root.querySelectorAll('[data-bronkey-variant-sku]').forEach((field) => {
      field.textContent = sku || '—';
    });
    root.querySelectorAll('[data-bronkey-variant-barcode]').forEach((field) => {
      field.textContent = barcode;
    });
    root.querySelectorAll('[data-bronkey-variant-barcode-row]').forEach((row) => {
      row.hidden = !barcode;
    });
  }, true);
})();
